import { AVATAR_COLOURS } from '@omnea-app/omui/avatarColours'

// Picks a stable avatar colour from a subject's id (user/group/contact), so the same
// subject is always the same colour wherever their avatar is shown.
export const colourFromIdentity = (identity: string): string => {
  const normalised = identity.trim().toLowerCase()

  let hash = 0
  for (let i = 0; i < normalised.length; i++) {
    hash = (hash * 31 + normalised.charCodeAt(i)) | 0
  }

  return AVATAR_COLOURS[Math.abs(hash) % AVATAR_COLOURS.length] ?? AVATAR_COLOURS[0]
}
